import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Users14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.25 3.5C2.25 2.25736 3.25736 1.25 4.5 1.25C5.74264 1.25 6.75 2.25736 6.75 3.5C6.75 4.74264 5.74264 5.75 4.5 5.75C3.25736 5.75 2.25 4.74264 2.25 3.5ZM4.5 2.75C4.08579 2.75 3.75 3.08579 3.75 3.5C3.75 3.91421 4.08579 4.25 4.5 4.25C4.91421 4.25 5.25 3.91421 5.25 3.5C5.25 3.08579 4.91421 2.75 4.5 2.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.5 3.25C8.25736 3.25 7.25 4.25736 7.25 5.5C7.25 6.74264 8.25736 7.75 9.5 7.75C10.7426 7.75 11.75 6.74264 11.75 5.5C11.75 4.25736 10.7426 3.25 9.5 3.25ZM8.75 5.5C8.75 5.08579 9.08579 4.75 9.5 4.75C9.91421 4.75 10.25 5.08579 10.25 5.5C10.25 5.91421 9.91421 6.25 9.5 6.25C9.08579 6.25 8.75 5.91421 8.75 5.5Z'
      fill='currentColor'
    />
    <path
      d='M8 8.25C6.48122 8.25 5.25 9.48122 5.25 11V12H6.75V11C6.75 10.3096 7.30964 9.75 8 9.75H11C11.6904 9.75 12.25 10.3096 12.25 11V12H13.75V11C13.75 9.48122 12.5188 8.25 11 8.25H8Z'
      fill='currentColor'
    />
    <path
      d='M3 6.25C1.48122 6.25 0.25 7.48122 0.25 9V10H1.75V9C1.75 8.30964 2.30964 7.75 3 7.75H6V6.25H3Z'
      fill='currentColor'
    />
  </Svg>
);

Users14.displayName = 'Users14';
export default Users14;
